/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Answer/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CheckMark from './CheckMark/index'
import Question from './Question/index'
import React from 'react'
import Response from './Response/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Answer({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Answer",
  isDisabled,
  isReminder
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled})
let dtAnswerBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.backgroundColor.brand.base'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtAnswerBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.borderColor.brand.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtAnswerBackgroundcolorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.backgroundColor.brand.disabled'
        })
let dtAnswerBordercolorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.borderColor.brand.disabled'
        })
let dtAnswerBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.backgroundColor.brand.hovered'
        })
let dtAnswerBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.borderColor.brand.hovered'
        })
let dtAnswerBordercolorBrandReminder = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Answer.borderColor.brand.reminder'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isDisabled,
  isReminder,
  isHovered
  
})
  return (<React.Fragment
>
<button
  data-testid="Answer.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--bblr-3-2jYCup': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-4-2jYCup': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-7-2jYCup': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-8-2jYCup': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-2jYCup': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-10-2jYCup': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-2jYCup': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-12-2jYCup': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-1-2jYCup': isHovered ? dtAnswerBackgroundcolorBrandHovered : isReminder ? dtAnswerBordercolorBrandReminder : dtAnswerBackgroundcolorBrandBase,'--bc-2-2jYCup': isHovered ? dtAnswerBordercolorBrandHovered : dtAnswerBordercolorBrandBase,'--bs-5-2jYCup': isHovered ? "solid" : "solid",'--btlr-6-2jYCup': isHovered ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Answer.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Question
  viewPath={`${viewPath}/Question`}
/>
<Response
  viewPath={`${viewPath}/Response`}
/>
</div>
<CheckMark
  viewPath={`${viewPath}/CheckMark`}
/>
</button>
{children}
</React.Fragment>)
}